import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CustomerService_GetCustomerDataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/customer/service.grpc.lazy';
import {GetCustomerDataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/customer/service.types';
import {createDataStore} from '../createDataStore';
import {useUserToken} from '../userStore/user.selector';

const useExpensiveCustomerData = () => {
  const authToken = useUserToken();

  return useGrpcRequest(
    CustomerService_GetCustomerDataLazy,
    {
      customerSession: {authToken: authToken!},
    },
    {
      disabled: !authToken,
      keepPreviousData: false,
    },
  );
};

const {Provider, useData: useCustomerData} = createDataStore<
  GetCustomerDataResponse | undefined
>({
  defaultValue: undefined,
  useQueryHook: useExpensiveCustomerData,
});

export {Provider as CustomerProvider, useCustomerData};
